'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dI$002dP$0024$0024anon$002477 from "./presto.types$-I-P$$anon$77.js";
var $p;
/** @constructor */
function $c_Lpresto_types$IP$() {
  this.c7T = null;
  this.c7U = false;
  this.c7R = null;
  this.c7S = false;
  this.c7P = null;
  this.c7Q = false;
  this.c7V = null;
  this.c7W = false;
}
export { $c_Lpresto_types$IP$ as $c_Lpresto_types$IP$ };
$p = $c_Lpresto_types$IP$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$IP$;
/** @constructor */
function $h_Lpresto_types$IP$() {
}
export { $h_Lpresto_types$IP$ as $h_Lpresto_types$IP$ };
$h_Lpresto_types$IP$.prototype = $p;
$p.cIK = (function() {
  if ((!this.c7U)) {
    this.c7T = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c7U = true;
  }
  return this.c7T;
});
$p.cs4 = (function() {
  if ((!this.c7S)) {
    this.c7R = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD;
    this.c7S = true;
  }
  return this.c7R;
});
$p.cHI = (function() {
  if ((!this.c7Q)) {
    this.c7P = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c7Q = true;
  }
  return this.c7P;
});
$p.cJ3 = (function() {
  if ((!this.c7W)) {
    this.c7V = new $j_presto$002etypes$0024$002dI$002dP$0024$0024anon$002477.$c_Lpresto_types$IP$$anon$77(this);
    this.c7W = true;
  }
  return this.c7V;
});
var $d_Lpresto_types$IP$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$IP$, "presto.types$IP$", ({
  a0t: 1,
  D: 1
}));
export { $d_Lpresto_types$IP$ as $d_Lpresto_types$IP$ };
var $n_Lpresto_types$IP$;
function $m_Lpresto_types$IP$() {
  if ((!$n_Lpresto_types$IP$)) {
    $n_Lpresto_types$IP$ = new $c_Lpresto_types$IP$();
  }
  return $n_Lpresto_types$IP$;
}
export { $m_Lpresto_types$IP$ as $m_Lpresto_types$IP$ };
//# sourceMappingURL=presto.types$-I-P$.js.map
